export enum SidebarType {
  FIXED = 'fixed',
  CONDENSED = 'condensed',
  SCROLLABLE = 'scrollable',
}
